import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  Tab,
  Tabs,
  Table,
  Spinner,
  Form,
  Button,
  Alert,
  Card,
  Row,
  Col,
} from "react-bootstrap";
import {
  MdLogout,
  MdUpload,
  MdDownload,
  MdSearch,
  MdCheckCircle,
  MdError,
  MdPerson,
} from "react-icons/md";
import asignacionCamasTrabajadoresApi from "../../../services/api/asignacionCamasTrabajadoresApi";
import * as XLSX from "xlsx";
import "react-toastify/dist/ReactToastify.css";

const CheckoutManual = () => {
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "null");

  const [activeTab, setActiveTab] = useState("individual");

  const [dni, setDni] = useState("");
  const [autoPad8Individual, setAutoPad8Individual] = useState(false);
  const [buscandoPreview, setBuscandoPreview] = useState(false);
  const [ejecutandoCheckout, setEjecutandoCheckout] = useState(false);
  const [previewIndividual, setPreviewIndividual] = useState(null);

  const [fileMasivo, setFileMasivo] = useState(null);
  const [autoPad8Masivo, setAutoPad8Masivo] = useState(false);
  const [validandoMasivo, setValidandoMasivo] = useState(false);
  const [procesandoMasivo, setProcesandoMasivo] = useState(false);
  const [resultadoValidacion, setResultadoValidacion] = useState(null);
  const [resultadoMasivo, setResultadoMasivo] = useState(null);

  const showToast = (type, message) => {
    const opts = { position: "bottom-right", autoClose: 3500 };
    if (type === "success") toast.success(message, opts);
    else if (type === "error") toast.error(message, opts);
    else if (type === "warning") toast.warning(message, opts);
    else toast.info(message, opts);
  };

  const onChangeDniIndividual = (value) => {
    setDni(value);
    setPreviewIndividual(null);
  };

  const onChangePad8Individual = (checked) => {
    setAutoPad8Individual(checked);
    setPreviewIndividual(null);
  };

  const buscarIndividual = async () => {
    if (!dni.trim()) {
      showToast("error", "Ingrese un DNI");
      return;
    }
    if (!selectedProject?.id) {
      showToast("error", "Seleccione un proyecto");
      return;
    }
    setBuscandoPreview(true);
    setPreviewIndividual(null);
    try {
      const response = await asignacionCamasTrabajadoresApi.buscarCheckoutIndividual(
        dni.trim(),
        selectedProject.id,
        autoPad8Individual
      );
      if (response.data?.success && response.data?.data) {
        setPreviewIndividual(response.data.data);
        showToast("success", response.data.message || "Datos cargados");
      } else {
        showToast("error", response.data?.message || "No se encontró un check-in activo");
      }
    } catch (err) {
      const msg =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Error de conexión o del servidor";
      showToast("error", typeof msg === "string" ? msg : "Error al buscar");
    } finally {
      setBuscandoPreview(false);
    }
  };

  const handleCheckoutIndividual = async () => {
    if (!dni.trim()) {
      showToast("error", "Ingrese un DNI");
      return;
    }
    if (!selectedProject?.id) {
      showToast("error", "Seleccione un proyecto");
      return;
    }
    if (!previewIndividual) {
      showToast("warning", "Primero busque y confirme los datos del trabajador");
      return;
    }
    setEjecutandoCheckout(true);
    try {
      const response = await asignacionCamasTrabajadoresApi.checkout(
        dni.trim(),
        selectedProject.id,
        autoPad8Individual
      );
      if (response.data?.success) {
        const data = response.data.data || {};
        showToast("success", response.data.message || "Check-out exitoso");
        toast.info(
          `Cama liberada: ${data.cama || "—"} (Hab. ${data.habitacion || "—"})`,
          { position: "bottom-right", autoClose: 6000 }
        );
        setDni("");
        setPreviewIndividual(null);
      } else {
        showToast("error", response.data?.message || "No se pudo realizar el check-out");
      }
    } catch (err) {
      const msg =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Error de conexión o del servidor";
      showToast("error", typeof msg === "string" ? msg : "Error al procesar check-out");
    } finally {
      setEjecutandoCheckout(false);
    }
  };

  const descargarPlantilla = () => {
    const plantilla = [
      { "Numero Documento Identidad": "12345678" },
      { "Numero Documento Identidad": "87654321" },
    ];
    const ws = XLSX.utils.json_to_sheet(plantilla);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Check-Out Manual");
    XLSX.writeFile(wb, "Plantilla_CheckOut_Manual.xlsx");
    showToast("info", "Plantilla descargada");
  };

  const handleFileChange = (e) => {
    const f = e.target.files?.[0];
    setFileMasivo(f || null);
    setResultadoValidacion(null);
    setResultadoMasivo(null);
  };

  const validarMasivo = async () => {
    if (!fileMasivo) {
      showToast("error", "Seleccione un archivo Excel");
      return;
    }
    if (!selectedProject?.id) {
      showToast("error", "Seleccione un proyecto");
      return;
    }
    setValidandoMasivo(true);
    setResultadoValidacion(null);
    try {
      const response = await asignacionCamasTrabajadoresApi.validarCheckoutMasivo(
        fileMasivo,
        selectedProject.id,
        autoPad8Masivo
      );
      setResultadoValidacion(response.data);
      if (response.data?.success) {
        const nOk = response.data.pueden_checkout ?? 0;
        const nNo = response.data.no_aplican_count ?? 0;
        showToast(
          nNo > 0 ? "warning" : "success",
          `Validación: ${nOk} pueden check-out, ${nNo} no aplican`
        );
      } else {
        showToast("error", response.data?.message || "Error al validar");
      }
    } catch (err) {
      showToast("error", err.response?.data?.detail || "Error al validar archivo");
      setResultadoValidacion(null);
    } finally {
      setValidandoMasivo(false);
    }
  };

  const procesarMasivo = async () => {
    if (!fileMasivo) {
      showToast("error", "Seleccione un archivo Excel");
      return;
    }
    if (!selectedProject?.id) {
      showToast("error", "Seleccione un proyecto");
      return;
    }
    setProcesandoMasivo(true);
    setResultadoMasivo(null);
    try {
      const response = await asignacionCamasTrabajadoresApi.checkoutMasivo(
        fileMasivo,
        selectedProject.id,
        autoPad8Masivo
      );
      setResultadoMasivo(response.data);
      if (response.data?.success) {
        const ex = response.data.exitosos ?? 0;
        const fa = response.data.fallidos ?? 0;
        if (fa === 0) showToast("success", `Check-out masivo: ${ex} exitosos`);
        else if (ex > 0) showToast("warning", `${ex} exitosos, ${fa} no procesados`);
        else showToast("error", "Ningún check-out se pudo completar");
      } else {
        showToast("error", response.data?.message || "Error en proceso masivo");
      }
    } catch (err) {
      showToast("error", err.response?.data?.detail || "Error al procesar");
      setResultadoMasivo(null);
    } finally {
      setProcesandoMasivo(false);
    }
  };

  const descargarFallidos = () => {
    const lista = resultadoMasivo?.detalle_fallidos;
    if (!lista?.length) {
      showToast("error", "No hay fallidos para exportar");
      return;
    }
    const rows = lista.map((r) => ({
      Fila: r.fila,
      DNI: r.dni,
      Motivo: r.error,
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Fallidos");
    XLSX.writeFile(wb, "CheckOut_Manual_Fallidos.xlsx");
    showToast("info", "Archivo descargado");
  };

  return (
    <div className="container-fluid py-4">
      <ToastContainer />
      <div
        className="mb-4 p-4 rounded-3 text-white"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <h1 className="h3 mb-1 d-flex align-items-center gap-2">
          <MdLogout size={28} />
          Check-out manual
        </h1>
        <p className="mb-0 opacity-90">
          Check-out individual o masivo por Excel (solo trabajadores con check-in activo /
          ocupada).
        </p>
      </div>

      <Card className="shadow-sm">
        <Card.Body>
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => k && setActiveTab(k)}
            className="mb-3"
          >
            <Tab
              eventKey="individual"
              title={
                <span className="d-flex align-items-center gap-1">
                  <MdPerson size={18} />
                  Individual
                </span>
              }
            >
              <div className="p-2 p-md-3">
                <Alert variant="info">
                  Ingrese el DNI y pulse <strong>Buscar</strong>. Si hay check-in activo, verá los
                  datos en la grilla y podrá confirmar con <strong>Realizar check-out</strong>.
                </Alert>
                <Row className="g-3 align-items-end mb-3">
                  <Col md={5}>
                    <Form.Group>
                      <Form.Label>DNI</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Ej: 12345678"
                        value={dni}
                        onChange={(e) => onChangeDniIndividual(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            buscarIndividual();
                          }
                        }}
                        disabled={buscandoPreview || ejecutandoCheckout}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Check
                      type="checkbox"
                      id="pad8-ind"
                      label="Completar DNI con ceros a la izquierda hasta 8 dígitos"
                      checked={autoPad8Individual}
                      onChange={(e) => onChangePad8Individual(e.target.checked)}
                      disabled={buscandoPreview || ejecutandoCheckout}
                    />
                  </Col>
                  <Col md={3}>
                    <Button
                      type="button"
                      variant="primary"
                      className="w-100"
                      onClick={buscarIndividual}
                      disabled={buscandoPreview || ejecutandoCheckout}
                      style={{
                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        border: "none",
                      }}
                    >
                      {buscandoPreview ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Buscando...
                        </>
                      ) : (
                        <>
                          <MdSearch className="me-2" />
                          Buscar
                        </>
                      )}
                    </Button>
                  </Col>
                </Row>

                {previewIndividual && (
                  <>
                    <h6 className="mb-2 text-secondary">Datos del hospedaje</h6>
                    <div className="table-responsive mb-3">
                      <Table striped bordered hover size="sm" className="mb-0 align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>DNI</th>
                            <th>Nombres y apellidos</th>
                            <th>Zona</th>
                            <th>Módulo</th>
                            <th>Habitación</th>
                            <th>Cama</th>
                            <th>Fecha reserva</th>
                            <th>Fecha check-in</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-nowrap">{previewIndividual.dni || "—"}</td>
                            <td>{previewIndividual.nombres_y_apellidos || "—"}</td>
                            <td>{previewIndividual.zona}</td>
                            <td>{previewIndividual.modulo}</td>
                            <td>{previewIndividual.habitacion}</td>
                            <td>{previewIndividual.cama}</td>
                            <td className="text-nowrap">
                              {previewIndividual.fecha_reserva_formateada || "—"}
                            </td>
                            <td className="text-nowrap">
                              {previewIndividual.fecha_check_in_formateada || "—"}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    <Button
                      type="button"
                      variant="danger"
                      onClick={handleCheckoutIndividual}
                      disabled={ejecutandoCheckout || buscandoPreview}
                    >
                      {ejecutandoCheckout ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Procesando check-out...
                        </>
                      ) : (
                        <>
                          <MdLogout className="me-2" />
                          Realizar check-out
                        </>
                      )}
                    </Button>
                  </>
                )}
              </div>
            </Tab>

            <Tab
              eventKey="masivo"
              title={
                <span className="d-flex align-items-center gap-1">
                  <MdUpload size={18} />
                  Masivo
                </span>
              }
            >
              <div className="p-2 p-md-3">
                <Alert variant="info">
                  Archivo Excel con columna <strong>Numero Documento Identidad</strong>. Use{" "}
                  <strong>Validar</strong> para ver qué DNIs no tienen check-in activo. Luego{" "}
                  <strong>Procesar check-out masivo</strong> ejecuta los check-out válidos.
                </Alert>
                <Row className="g-3 mb-3 align-items-center">
                  <Col xs={12} md="auto">
                    <Button variant="outline-primary" onClick={descargarPlantilla}>
                      <MdDownload className="me-2" />
                      Descargar plantilla
                    </Button>
                  </Col>
                  <Col xs={12} md="auto">
                    <Form.Label
                      htmlFor="checkout-manual-excel"
                      className="btn btn-outline-secondary mb-0"
                    >
                      <MdUpload className="me-2" />
                      Seleccionar Excel
                    </Form.Label>
                    <Form.Control
                      id="checkout-manual-excel"
                      type="file"
                      accept=".xlsx,.xls"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                  </Col>
                </Row>
                {fileMasivo && (
                  <Alert variant="secondary" className="py-2">
                    Archivo: <strong>{fileMasivo.name}</strong>
                  </Alert>
                )}
                <Form.Check
                  type="checkbox"
                  id="pad8-mas"
                  className="mb-3"
                  label="Completar DNI con ceros a la izquierda hasta 8 dígitos"
                  checked={autoPad8Masivo}
                  onChange={(e) => setAutoPad8Masivo(e.target.checked)}
                />
                <div className="d-flex flex-wrap gap-2 mb-4">
                  <Button
                    variant="info"
                    onClick={validarMasivo}
                    disabled={validandoMasivo || !fileMasivo}
                  >
                    {validandoMasivo ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Validando...
                      </>
                    ) : (
                      <>
                        <MdSearch className="me-2" />
                        Validar archivo
                      </>
                    )}
                  </Button>
                  <Button
                    variant="danger"
                    onClick={procesarMasivo}
                    disabled={procesandoMasivo || !fileMasivo}
                  >
                    {procesandoMasivo ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Procesando...
                      </>
                    ) : (
                      <>
                        <MdLogout className="me-2" />
                        Procesar check-out masivo
                      </>
                    )}
                  </Button>
                </div>

                {resultadoValidacion?.success && (
                  <Card className="mb-4 border-primary">
                    <Card.Header className="bg-primary text-white">
                      Resultado de validación
                    </Card.Header>
                    <Card.Body>
                      <Row className="text-center g-2 mb-3">
                        <Col md={4}>
                          <div className="text-muted small">Filas con DNI</div>
                          <div className="h4 mb-0">{resultadoValidacion.total_filas}</div>
                        </Col>
                        <Col md={4}>
                          <div className="text-muted small">Pueden check-out</div>
                          <div className="h4 mb-0 text-success">
                            {resultadoValidacion.pueden_checkout}
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="text-muted small">No tienen check-in activo / otros</div>
                          <div className="h4 mb-0 text-warning">
                            {resultadoValidacion.no_aplican_count}
                          </div>
                        </Col>
                      </Row>
                      {resultadoValidacion.detalle_no_aplican?.length > 0 && (
                        <>
                          <h6 className="mt-3">DNIs que no tienen check-in activo (u otros)</h6>
                          <div style={{ maxHeight: 320, overflowY: "auto" }}>
                            <Table striped bordered hover size="sm">
                              <thead>
                                <tr>
                                  <th>Fila</th>
                                  <th>DNI (celda)</th>
                                  <th>DNI consultado</th>
                                  <th>Trabajador</th>
                                  <th>Motivo</th>
                                </tr>
                              </thead>
                              <tbody>
                                {resultadoValidacion.detalle_no_aplican.map((r, i) => (
                                  <tr key={i}>
                                    <td>{r.fila}</td>
                                    <td>{r.dni_celda || "—"}</td>
                                    <td>{r.dni_consultado || "—"}</td>
                                    <td>{r.trabajador || "—"}</td>
                                    <td>{r.mensaje}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        </>
                      )}
                    </Card.Body>
                  </Card>
                )}

                {resultadoMasivo?.success && (
                  <Card className="border-success">
                    <Card.Header className="bg-success text-white d-flex flex-wrap align-items-center justify-content-between gap-2">
                      <span>Resultado check-out masivo</span>
                      {resultadoMasivo.detalle_fallidos?.length > 0 && (
                        <Button size="sm" variant="light" onClick={descargarFallidos}>
                          <MdDownload className="me-1" />
                          Exportar fallidos
                        </Button>
                      )}
                    </Card.Header>
                    <Card.Body>
                      <Row className="text-center mb-3">
                        <Col md={6}>
                          <MdCheckCircle className="text-success mb-2" size={36} />
                          <div className="h3 text-success">{resultadoMasivo.exitosos}</div>
                          <div className="text-muted">Exitosos</div>
                        </Col>
                        <Col md={6}>
                          <MdError className="text-danger mb-2" size={36} />
                          <div className="h3 text-danger">{resultadoMasivo.fallidos}</div>
                          <div className="text-muted">No procesados</div>
                        </Col>
                      </Row>
                      {resultadoMasivo.detalle_fallidos?.length > 0 && (
                        <div style={{ maxHeight: 280, overflowY: "auto" }}>
                          <Table striped size="sm">
                            <thead>
                              <tr>
                                <th>Fila</th>
                                <th>DNI</th>
                                <th>Motivo</th>
                              </tr>
                            </thead>
                            <tbody>
                              {resultadoMasivo.detalle_fallidos.map((r, i) => (
                                <tr key={i}>
                                  <td>{r.fila}</td>
                                  <td>{r.dni}</td>
                                  <td>{r.error}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                )}
              </div>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CheckoutManual;
